<div class="info">
  <div class="icon-wrapper">
    <app-icon [icon]="'swords'" [width]="20"></app-icon>
  </div>
  <div class="texts">
    <h3 class="title">Coinflip #{{ coinflip.gameid }}</h3>
    <div class="subtitle">
      <span>
        {{ coinflip?.host?.name | name }}
      </span>
      <span [class.dots]="!coinflip?.part?.name">vs</span>
      <span>
        {{ coinflip?.part?.name ?? '' | name }}
      </span>
    </div>
  </div>
</div>

<div class="main">
  @if (coinflip.status === 'open' || coinflip.status === 'finished' || (coinflip?.part.reveal || coinflip.status === 'joining')) {
  <app-coinflip-coin
    [coinflip]="coinflip"
    [size]="uiService.screenSize === 'XSmall' ? 82 : 122"
    [anim]="false"
    (onAnimStart)="animStart()"
    (onAnimEnd)="animEnd()"
  ></app-coinflip-coin>
  }
  <div class="circle">
    <span class="effect" [class.blur-blue]="animationEnded && coinflip?.winner?.side === 1" [class.blur-red]="animationEnded && coinflip?.winner?.side === 2"></span>
  </div>
  <!--  -->
  @if (coinflip.status === 'joined') {
  <div class="timer">
    {{ coinflip.timer | timeRemaining : 's' : true | async }}
  </div>
  }
  <!--  -->
  <!-- @if (coinflip.status === 'joining') {
  <div class="timer">
    {{ coinflip.timer | timeRemaining : 's' : true | async }}
  </div>
  } -->
</div>
